<script>
import { Bar, mixins } from 'vue-chartjs'

export default {
  extends: Bar,

  mixins: [ mixins.reactiveProp ],

  props: [ 'chartData', 'options' ],

  watch: {
    options: function () {
      this.renderChart(this.chartData, this.options)
    }
  },

  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Charts/YearChart.vue